// ----------------------------------------------------------------------------------------------------
// -----------------               Right side bar of Home screen                     ------------------
// ----------------------------------------------------------------------------------------------------

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'canano-right-side-bar',
  templateUrl: './right-side-bar.component.html',
  styleUrls: ['right-side-bar.scss']
})
export class RightSideBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
